import React from 'react';
import { SideNavLink } from '@carbon/react';
import { Link } from 'gatsby';
import { Launch as LaunchIcon, Locked as LockedIcon } from '@carbon/react/icons';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { outboundLink, divider, dividerSpace } from './LeftNav.module.scss';

const LeftNavResourceLinks = ({
  links,
  shouldOpenNewTabs,
  includeDividerSpace = true,
}) => {
  if (!links) return null;

  const shouldOpenNewTabsProps = {
    ...(shouldOpenNewTabs && { rel: 'noopener noreferrer', target: '_blank' }),
  };

  return (
    <>
      <hr
        className={cx(divider, {
          [dividerSpace]: includeDividerSpace,
        })}
      />
      <div className="resources">
        {links.map(({ title, href, locked, ...rest }, i) => {
          const isExternal = /^https?:\/\//.test(href);
          const renderIcon = locked
            ? LockedIcon // Display lock icon if `locked` is true
            : isExternal
            ? LaunchIcon
            : undefined;
            // const isCurrent = window.location.pathname === href;
          return (
            <SideNavLink
              key={i}
              renderIcon={renderIcon}
              aria-current={""}
              className={cx({ [outboundLink]: isExternal })}
              element={isExternal ? 'a' : Link} // Use Link for internal links
              {...(isExternal ? { href } : { to: href })}
              {...shouldOpenNewTabsProps}
              {...rest}
              aria-label={`${title} ${isExternal?"opens in new Tab/Window":""}`}
            >
              {title}
            </SideNavLink>
          );
        })}
      </div>
    </>
  );
};

LeftNavResourceLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      locked: PropTypes.bool,
    })
  ),
  shouldOpenNewTabs: PropTypes.bool,
  includeDividerSpace: PropTypes.bool,
};

export default LeftNavResourceLinks;
